import httpClient from "./httpClient";

// --- Fee configuration (FeeConfigController) ---
export function listSubHeadConfigs(feeHeadId) {
  return httpClient.get("/fee-config/subhead", { params: { feeHeadId } }).then((res) => res.data.data);
}
export function createSubHeadConfig(payload) {
  return httpClient.post("/fee-config/subhead", payload).then((res) => res.data.data);
}
export function deleteSubHeadConfig(id) {
  return httpClient.delete(`/fee-config/subhead/${id}`).then((res) => res.data);
}

export function listAmountConfigs(classId) {
  return httpClient.get("/fee-config/amount", { params: { classId } }).then((res) => res.data.data);
}
export function saveAmountConfig(payload) {
  return httpClient.post("/fee-config/amount", payload).then((res) => res.data.data);
}
export function deleteAmountConfig(id) {
  return httpClient.delete(`/fee-config/amount/${id}`).then((res) => res.data);
}

export function listTimeConfigs(payableMonth, payableYear) {
  return httpClient.get("/fee-config/time", { params: { payableMonth, payableYear } }).then((res) => res.data.data);
}
export function saveTimeConfig(payload) {
  return httpClient.post("/fee-config/time", payload).then((res) => res.data.data);
}
export function deleteTimeConfig(id) {
  return httpClient.delete(`/fee-config/time/${id}`).then((res) => res.data);
}

// --- Fee ledger configuration (FeeLedgerConfigController) ---
export function listFeeHeadLedgers() {
  return httpClient.get("/fee-ledger-config/fee-head").then((res) => res.data.data);
}
export function saveFeeHeadLedger(payload) {
  return httpClient.post("/fee-ledger-config/fee-head", payload).then((res) => res.data.data);
}
export function deleteFeeHeadLedger(id) {
  return httpClient.delete(`/fee-ledger-config/fee-head/${id}`).then((res) => res.data);
}

export function listFeeFineLedgers() {
  return httpClient.get("/fee-ledger-config/fee-fine").then((res) => res.data.data);
}
export function saveFeeFineLedger(payload) {
  return httpClient.post("/fee-ledger-config/fee-fine", payload).then((res) => res.data.data);
}
export function deleteFeeFineLedger(id) {
  return httpClient.delete(`/fee-ledger-config/fee-fine/${id}`).then((res) => res.data);
}

export function listAutoLedgerMappings() {
  return httpClient.get("/fee-ledger-config/auto-ledger").then((res) => res.data.data);
}
export function saveAutoLedgerMapping(payload) {
  return httpClient.post("/fee-ledger-config/auto-ledger", payload).then((res) => res.data.data);
}
export function deleteAutoLedgerMapping(id) {
  return httpClient.delete(`/fee-ledger-config/auto-ledger/${id}`).then((res) => res.data);
}

// --- Per-student fee adjustments (FeeAdjustmentController) ---
export function listWaiverGrants(identificationId) {
  return httpClient.get("/fee-adjustments/waivers", { params: { identificationId } }).then((res) => res.data.data);
}
export function grantWaiver(payload) {
  return httpClient.post("/fee-adjustments/waivers", payload).then((res) => res.data.data);
}
export function deleteWaiverGrant(id) {
  return httpClient.delete(`/fee-adjustments/waivers/${id}`).then((res) => res.data);
}

export function listIndividualAssigns(identificationId) {
  return httpClient.get("/fee-adjustments/individual-assign", { params: { identificationId } }).then((res) => res.data.data);
}
export function saveIndividualAssign(payload) {
  return httpClient.post("/fee-adjustments/individual-assign", payload).then((res) => res.data.data);
}
export function deleteIndividualAssign(id) {
  return httpClient.delete(`/fee-adjustments/individual-assign/${id}`).then((res) => res.data);
}

export function listDiscards(identificationId) {
  return httpClient.get("/fee-adjustments/discards", { params: { identificationId } }).then((res) => res.data.data);
}
export function discardFeeHead(payload) {
  return httpClient.post("/fee-adjustments/discards", payload).then((res) => res.data.data);
}
export function deleteDiscard(id) {
  return httpClient.delete(`/fee-adjustments/discards/${id}`).then((res) => res.data);
}

// --- Bulk fee adjustments (real digicampusbd roster-search-then-bulk-act workflows) ---
export function grantWaiverBulk(payload) {
  return httpClient.post("/fee-adjustments/waivers/bulk", payload).then((res) => res.data.data);
}
export function listWaiverGrantsBySection(classConfigurationId, studentCategoryId, academicYear) {
  return httpClient
    .get("/fee-adjustments/waivers/by-section", { params: { classConfigurationId, studentCategoryId, academicYear } })
    .then((res) => res.data.data);
}
export function updateWaiverGrant(id, payload) {
  return httpClient.put(`/fee-adjustments/waivers/${id}`, payload).then((res) => res.data.data);
}

export function individualAssignRoster(feeHeadId, feeSubHeadIds, classConfigurationId, academicYear) {
  const query = new URLSearchParams();
  query.append("feeHeadId", feeHeadId);
  query.append("classConfigurationId", classConfigurationId);
  query.append("academicYear", academicYear);
  feeSubHeadIds.forEach((id) => query.append("feeSubHeadIds", id));
  return httpClient.get(`/fee-adjustments/individual-assign/roster?${query.toString()}`).then((res) => res.data.data);
}
export function saveIndividualAssignBulk(payload) {
  return httpClient.post("/fee-adjustments/individual-assign/bulk", payload).then((res) => res.data.data);
}

export function feeSubHeadRemoveRoster(feeHeadId, classConfigurationId, academicYear) {
  return httpClient
    .get("/fee-adjustments/subhead-remove/roster", { params: { feeHeadId, classConfigurationId, academicYear } })
    .then((res) => res.data.data);
}
export function feeSubHeadRemove(payload) {
  return httpClient.post("/fee-adjustments/subhead-remove", payload).then((res) => res.data.data);
}
export function listRemovedFeeSubHeads(feeHeadId, classConfigurationId, academicYear) {
  return httpClient
    .get("/fee-adjustments/subhead-remove/removed", { params: { feeHeadId, classConfigurationId, academicYear } })
    .then((res) => res.data.data);
}
export function reAssignFeeSubHeads(detailsIds) {
  const query = new URLSearchParams();
  detailsIds.forEach((id) => query.append("detailsIds", id));
  return httpClient.post(`/fee-adjustments/subhead-remove/reassign?${query.toString()}`).then((res) => res.data.data);
}

// --- Fee collection / invoices (FeeInvoiceController) ---
export function collectFee(payload) {
  return httpClient.post("/fee-invoices/collect", payload).then((res) => res.data.data);
}
export function getFeeCollectionView(identificationId, academicYear) {
  return httpClient
    .get("/fee-invoices/collection-view", { params: { identificationId, academicYear } })
    .then((res) => res.data.data);
}
export function getFeeCollectionViewByCustomStudentId(customStudentId, academicYear) {
  return httpClient
    .get("/fee-invoices/collection-view-by-custom-id", { params: { customStudentId, academicYear } })
    .then((res) => res.data.data);
}
export function listInvoicesForStudent(identificationId) {
  return httpClient.get("/fee-invoices", { params: { identificationId } }).then((res) => res.data.data);
}
export function listInvoicesBetween(fromDate, toDate) {
  return httpClient.get("/fee-invoices/range", { params: { fromDate, toDate } }).then((res) => res.data.data);
}
export function getInvoice(masterId) {
  return httpClient.get(`/fee-invoices/${masterId}`).then((res) => res.data.data);
}
export function deleteInvoice(masterId) {
  return httpClient.delete(`/fee-invoices/${masterId}`).then((res) => res.data);
}

// --- Money receipt (MoneyReceiptController) ---
export function getMoneyReceipt(masterId) {
  return httpClient.get(`/money-receipt/${masterId}`).then((res) => res.data.data);
}
export function getReceiptTemplate() {
  return httpClient.get("/money-receipt/template").then((res) => res.data.data);
}
export function saveReceiptTemplate(payload) {
  return httpClient.post("/money-receipt/template", payload).then((res) => res.data.data);
}

// --- Reports (FeeReportController) ---
export function getDueList(academicYear, classConfigId) {
  return httpClient.get("/fee-reports/due", { params: { academicYear, classConfigId } }).then((res) => res.data.data);
}

export function getMonthWiseDueList(academicYear, classConfigId, groupId, months) {
  const query = new URLSearchParams();
  query.append("academicYear", academicYear);
  query.append("classConfigId", classConfigId);
  if (groupId) query.append("groupId", groupId);
  (months || []).forEach((m) => query.append("months", m));
  return httpClient.get(`/fee-reports/monthly-due?${query.toString()}`).then((res) => res.data.data);
}

export function getFeeHeadWisePaidList(academicYear, classConfigId, feeHeadId) {
  return httpClient.get("/fee-reports/feehead-paid-list", { params: { academicYear, classConfigId, feeHeadId } }).then((res) => res.data.data);
}

export function getSectionWisePaidSummary(fromDate, toDate, byShiftAndSection) {
  return httpClient
    .get("/fee-reports/section-paid-summary", { params: { fromDate, toDate, byShiftAndSection } })
    .then((res) => res.data.data);
}

export function getDateWiseSectionPaidSummary(fromDate, toDate) {
  return httpClient.get("/fee-reports/date-wise-section-paid-summary", { params: { fromDate, toDate } }).then((res) => res.data.data);
}

export function getSubCategoryDueList(academicYear, classConfigId, feeHeadId) {
  return httpClient.get("/fee-reports/sub-category-due-list", { params: { academicYear, classConfigId, feeHeadId } }).then((res) => res.data.data);
}

/** "Paid List Student Wise" (`fee-report-yearly-paid-list`) — see FeeReportService#paidListStudentWise's javadoc. */
export function getPaidListStudentWise(academicYear, classConfigId, feeSubHeadIds) {
  const query = new URLSearchParams();
  query.append("academicYear", academicYear);
  query.append("classConfigId", classConfigId);
  feeSubHeadIds.forEach((id) => query.append("feeSubHeadIds", id));
  return httpClient.get(`/fee-reports/paid-list-student-wise?${query.toString()}`).then((res) => res.data.data);
}

/** "Fee Due Info" (`fee-report-student-due-details`) — see FeeReportService#feeDueInfo's javadoc. */
export function getFeeDueInfo(academicYear, classConfigId, groupId, categoryId, feeHeadIds, months, startRoll, endRoll) {
  const query = new URLSearchParams();
  query.append("academicYear", academicYear);
  query.append("classConfigId", classConfigId);
  if (groupId) query.append("groupId", groupId);
  if (categoryId) query.append("categoryId", categoryId);
  feeHeadIds.forEach((id) => query.append("feeHeadIds", id));
  months.forEach((m) => query.append("months", m));
  query.append("startRoll", startRoll || 0);
  query.append("endRoll", endRoll || 0);
  return httpClient.get(`/fee-reports/fee-due-info?${query.toString()}`).then((res) => res.data.data);
}
